
            const data = {"name":"caret-down","data":{"width":"16","height":"8","viewBox":"0 0 16 8","data":"<path pid=\"0\" d=\"M0 .687.737.044c2.4 2.19 4.814 4.396 7.25 6.62L15.29 0c.269.263.506.5.711.705L8.006 8A8998.177 8998.177 0 0 0 0 .687z\" _fill=\"#7E7E7E\"/>","originalColors":[{"type":"fill","color":"#7E7E7E"}],"stopColors":[]}}
        
                    module.exports = data
                    